import * as React from 'react';
import { useIntl } from 'react-intl';
import { GetServerSidePropsContext } from 'next';

import { Layout } from '@components/layout';
import { GiftCertificateView } from '@components/PDP/giftCertificateView';
import { getPreviewToken, redirectOnError } from '@utils/helpers';
import api from '@services/api';
import { STORE_FRONT_KEY } from '@modules/plp';
import reportError from '@utils/reportError';
import { GiftCertificatePage } from '@definitions/giftCertificate.types';

export const getServerSideProps = async ({ req }: GetServerSidePropsContext) => {
  try {
    const token = getPreviewToken(req.headers.cookie);

    const { data } = await api.get('/general_pages/gift-certificate', {
      params: { storefrontKey: STORE_FRONT_KEY },
      headers: { cookie: req.headers.cookie || '', authorization: token },
    });

    if (!data) {
      return { notFound: true };
    }

    return {
      props: { giftCertificate: data },
    };
  } catch (e) {
    reportError(e);

    return redirectOnError(e);
  }
};
interface SlugProps {
  giftCertificate: GiftCertificatePage;
}

const GiftCertificate = ({ giftCertificate }: SlugProps) => {
  const intl = useIntl();
  const headerTitle = intl.formatMessage({ id: 'giftCertificate.headerTitle', defaultMessage: 'Gift Certificate' });

  return (
    <Layout title={headerTitle}>
      <GiftCertificateView variants={giftCertificate.variants} />
    </Layout>
  );
};

export default GiftCertificate;
